import React from 'react';
import { motion } from 'framer-motion';
import { Check, MessageCircle, Clock, Globe } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
const benefits = ['Diagnóstico emocional estratégico', 'Herramientas prácticas aplicables', 'Claridad sobre tu situación actual', 'Dirección emocional y mental', 'Plan inicial de reconstrucción personal', 'Acompañamiento y seguimiento'];
export function Benefits() {
  return <section className="py-24 md:py-32 bg-ink relative" data-id="element-44">
      <div className="container mx-auto px-6" data-id="element-45">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-47">
            <h2 className="text-3xl md:text-4xl font-serif text-ivory-bright mb-10" data-id="element-48">
              ¿Qué recibirás en la sesión?
            </h2>

            <ul className="space-y-6" data-id="element-49">
              {benefits.map((benefit, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} data-id="element-50">
                  <div className="mt-1 bg-gold/10 p-1 rounded-full text-gold" data-id="element-51">
                    <Check className="w-4 h-4" data-id="element-52" />
                  </div>
                  <span className="text-lg text-ivory/90 font-light" data-id="element-53">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="bg-ink-light border border-gold/30 relative overflow-hidden" data-id="element-54">
            {/* Featured image inside the price card */}
            <div className="relative bg-ink" data-id="element-55">
              <img src="https://cdn.magicpatterns.com/uploads/1XgMjjeanB8LxpvB69VoPm/Black,_Orange_and_White_Bold_LinkedIn_Marketing_Hacks_Carousel_(6).png" alt="Recupera tu paz emocional y reconstruye tu vida — Mentoría Estratégica 1 a 1 con Freddy Pimentel" className="w-full h-auto object-contain block" data-id="element-56" />
              <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-ink-light to-transparent pointer-events-none" data-id="element-57"></div>
            </div>

            <div className="p-8 md:p-10" data-id="element-58">
              <div className="text-center mb-8" data-id="element-59">
                <span className="inline-block text-gold text-xs tracking-[0.2em] uppercase font-semibold mb-5 px-3 py-1 border border-gold/30" data-id="element-60">
                  Valor de la Sesión
                </span>
              </div>
              <div className="text-center mb-8" data-id="element-61">
                <div className="flex items-baseline justify-center gap-4 mb-3 flex-wrap" data-id="element-62">
                  <span className="font-serif text-5xl md:text-6xl text-ivory-bright leading-none" data-id="element-63">
                    USD 30
                  </span>
                  <span className="text-muted text-2xl font-serif italic" data-id="element-64">
                    o
                  </span>
                  <span className="font-serif text-3xl md:text-4xl text-gold leading-none" data-id="element-65">
                    $30.000
                  </span>
                </div>
                <span className="text-muted text-sm tracking-widest uppercase" data-id="element-66">
                  Dólares · Pesos Argentinos
                </span>
              </div>

              <div className="space-y-4 border-y border-white/5 py-6 mb-8" data-id="element-67">
                <div className="flex items-center justify-between text-ivory/80 font-light" data-id="element-68">
                  <div className="flex items-center gap-3" data-id="element-69">
                    <Clock className="w-5 h-5 text-gold" data-id="element-70" />
                    <span data-id="element-71">Duración aproximada</span>
                  </div>
                  <span data-id="element-72">1 hora</span>
                </div>
                <div className="flex items-center justify-between text-ivory/80 font-light" data-id="element-73">
                  <div className="flex items-center gap-3" data-id="element-74">
                    <Globe className="w-5 h-5 text-gold" data-id="element-75" />
                    <span data-id="element-76">Modalidad</span>
                  </div>
                  <span data-id="element-77">Online</span>
                </div>
              </div>

              <div className="text-center space-y-6" data-id="element-78">
                <p className="text-muted text-sm italic leading-relaxed" data-id="element-79">
                  "Muchas personas pasan años intentando resolver solas lo que
                  podrían comenzar a transformar tomando una decisión diferente
                  hoy."
                </p>

                <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="w-full inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white hover:bg-[#1DA851] transition-colors duration-300 font-medium tracking-wide shadow-lg shadow-[#25D366]/20" data-id="element-80">
                  <MessageCircle className="w-5 h-5" data-id="element-81" />
                  QUIERO HABLAR CON FREDDY
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}